export default __webpack_public_path__ + "static/media/Swiss-Tangerine.2e91004a.jpg";